import { keyMirror } from 'ramda-extension';

export const buttonIconPositions = keyMirror({
	LEFT: null,
	RIGHT: null,
});
